import { ReportBarGraphSource } from '@ndt/report-output/shared/models/bar-graph-source-report-parameter';

export interface BarGraphSourceReportParameterValue {
   value: ReportBarGraphSource | any;
}

export const defaultBarGraphSourceParameter: BarGraphSourceReportParameterValue = {
   value: ReportBarGraphSource.Count,
};
